var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { attrs: { slot: "header" }, slot: "header" },
          [
            _c(
              "el-steps",
              {
                attrs: {
                  active: _vm.active,
                  "align-center": "",
                  "finish-status": "success",
                },
              },
              _vm._l(_vm.stepsEnum, function (step) {
                return _c("el-step", {
                  key: step.value,
                  attrs: { title: step.label },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("GoodsInfoVue", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active === 0,
                  expression: "active === 0",
                },
              ],
              ref: "goodsInfoRef",
              attrs: { cloneForm: _vm.form },
              on: { formChange: _vm.formChange },
            }),
            _vm._v(" "),
            _c("SpecificationsAndInventoryVue", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active === 1,
                  expression: "active === 1",
                },
              ],
              ref: "specificationsAndInventoryRef",
              attrs: { cloneForm: _vm.form },
              on: { formChange: _vm.formChange },
            }),
            _vm._v(" "),
            _c("GoodsDetailVue", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active === 2,
                  expression: "active === 2",
                },
              ],
              ref: "goodsDetailRef",
              attrs: { cloneForm: _vm.form },
              on: { formChange: _vm.formChange },
            }),
            _vm._v(" "),
            _vm.userType == 1
              ? _c("OtherVue", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 3,
                      expression: "active === 3",
                    },
                  ],
                  ref: "otherRef",
                  attrs: { cloneForm: _vm.form },
                  on: { formChange: _vm.formChange },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active > 0,
                    expression: "active > 0",
                  },
                ],
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.changeStep(-1)
                  },
                },
              },
              [_vm._v("上一步")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "default", loading: _vm.submitLoading },
                on: { click: _vm.handleEdit },
              },
              [_vm._v("取消")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active < _vm.stepsEnum.length - 1,
                    expression: "active < stepsEnum.length - 1",
                  },
                ],
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.changeStep(1)
                  },
                },
              },
              [_vm._v("下一步")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "success", loading: _vm.submitLoading },
                on: { click: _vm.submit },
              },
              [_vm._v("提交")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }